module.exports = "<ngx-loading-bar></ngx-loading-bar>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /builds/ulalachef/ulalachef-dashboard/src/app/components/app/app.component.html
// module id = ../../../../../src/app/components/app/app.component.html
// module chunks = main